import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import ProgressBar from '../ProgressBar';
import { isMatrixOpenEndedFamily, transformPrompt } from '../../utils';
import { getQuestionPrompt, isEmptyPrompt } from './utils';
import { QUESTION_CONVERSATIONAL } from '../../constants';

const AI_QUESTIONS = [QUESTION_CONVERSATIONAL];

export default function QuestionPrompt({
  question,
  showText = true,
  showPrompt = true,
  showProgressBar = true,
  showProgressBarQuestionIndex = true,
  showPromptQuestionIndex = false,
  questionIndex = 0,
}) {
  const { getText } = Pollfish.ui;
  const isQuestionAI = useMemo(() => AI_QUESTIONS.includes(question.style), [
    question,
  ]);
  const questionPrompt = useMemo(() => getQuestionPrompt(question, getText), [
    question,
    getText,
  ]);

  const { htmlPrompt } = question;
  let { prompt } = question;
  const isMatrixOpenEnded = isMatrixOpenEndedFamily(question);

  const isPollfishTheme = Boolean(Pollfish.helper.hasPollfishSurveyTheme());

  if (!isEmpty(htmlPrompt)) {
    prompt = htmlPrompt;
  }

  prompt = isQuestionAI
    ? getText('conversational.prompt')
    : transformPrompt(prompt);

  if (showPromptQuestionIndex) {
    prompt = `<span class="prompt-question-index">Q${questionIndex}.</span> ${prompt}`;
  }

  return (
    <div className="question-wrapper">
      <div className="question">
        {showProgressBar && (
          <ProgressBar
            showProgressBarQuestionIndex={showProgressBarQuestionIndex}
            questionIndex={questionIndex}
          />
        )}
        {showText && (
          <div
            className={classNames({
              'question__text inline-children': !(
                isMatrixOpenEnded && isEmptyPrompt(prompt)
              ),
            })}
            data-testid="question-text"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: prompt }}
          />
        )}
        {showPrompt && (
          <div
            className={classNames('question__prompt-wrapper', {
              'question__prompt-wrapper--ai': isQuestionAI && isPollfishTheme,
            })}
          >
            <div className="question__prompt" data-testid="question-prompt">
              {questionPrompt}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

QuestionPrompt.propTypes = {
  question: PropTypes.object,
  showText: PropTypes.bool,
  showPrompt: PropTypes.bool,
  showProgressBar: PropTypes.bool,
  showProgressBarQuestionIndex: PropTypes.bool,
  showPromptQuestionIndex: PropTypes.bool,
  questionIndex: PropTypes.number,
};
